import { useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import useForm from "../../../hooks/useForm"
import { ProductoI } from "../../../models/productos"
import { ProductoImagesI, addProducto, updateProducto } from "../../../services/productos/productos"

interface ImagenItem {
    titulo?: string;
    descripcion?: string;
    archivo?: File | null;
    archivoUrl?: string;
}


const initialStateValues = {
    id: '',
    activo: true,
    nombre: '',
    descripcion: '',
    categoria: '',
    sku: '',
    link_amazon:'',
    link_ml:'',
    imagen_complementaria:null,
    imagen_complementariaUrl:'',
    titulo_complementario: '',
    descripcion_complementaria: '',
    imagen_principal: null,
    imagen_principalUrl: '',
    infografia: null,
    infografiaUrl: '',
    meta_tags:'',
    labelDescargable:'',
    descargableCategoria:'',
    idDescargable:'',

    productos_imagenes: [],
    productos_imagenes_pequenas: [],
}

const useProductoAdd = (producto?: ProductoI) => {

    const [images, setImages] = useState<ProductoImagesI>({
        imgBackground: undefined,
        productos_imagenes: [],
        productos_imagenes_pequenas: [],
        imagen_principal: undefined,
        infografia: undefined,
    })
    const [imagenesEliminadas, setImagesEliminadas] = useState<string[]>([])
    const [imagenesPequenasEliminadas, setImagesPequenasEliminadas] = useState<string[]>([])
    const [loading, setLoading] = useState(false)

    const navigate = useNavigate()
    const { onChange, formData, setFormData } = useForm(producto || initialStateValues)
    const { id } = useParams()

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        try {
            const data = new FormData();
            const productoData = formData 
            setLoading(true)

            Object.keys(productoData).forEach((key) => {
                if(key === "imagen_complementaria" && productoData.imagen_complementaria){
                    data.append("imagen_complementaria", productoData.imagen_complementaria);
                }
                else if(key === "imagen_principal" && productoData.imagen_principal){
                    data.append("imagen_principal", productoData.imagen_principal);
                }
                else if(key === "infografia" && productoData.infografia){
                    data.append("infografia", productoData.infografia);
                }
                else if (key === 'productos_imagenes' || key === 'productos_imagenes_pequenas') {
                    const array = productoData[key as keyof ProductoI] as any[];
                    array.forEach((producto: any, index: number) => {
                        data.append(`${key}[${index}][titulo]`, producto.titulo || '');
                        data.append(`${key}[${index}][descripcion]`, producto.descripcion || '');
                        data.append(`${key}[${index}][orden]`, producto.orden || '');
                        if (producto.archivo) {
                            data.append(`imagen_${key}_${index}_archivo`, producto.archivo);
                        }
                        if (producto.archivoUrl) {
                            data.append(`imagen_${key}_${index}_imagen_old`, producto.archivoUrl);
                        }
                    });
                } else {
                    if (key in productoData) {
                        data.append(key, String(productoData[key as keyof ProductoI] || ''));
                    }
                }
            });

            data.append('productos_imagenes_eliminadas', JSON.stringify(imagenesEliminadas));
            data.append('productos_imagenes_pequenas_eliminadas', JSON.stringify(imagenesPequenasEliminadas));
            data.append('activo', '1');



            // Servicio que envia los datos al servidor
            await addProducto(data, images);
            setLoading(false)
            //navigate('/productos')
        } catch (e) {
            console.error(e)
            alert('Error al agregar el producto')
            setLoading(false)
        }
    }

    const handleImageFieldChange = (
        index: number, 
        field: 'titulo' | 'descripcion' | 'archivo', 
        value: string | File, 
        name: 'productos_imagenes' | 'productos_imagenes_pequenas'
    ) => {
        setFormData(prev => ({
            ...prev,
            [name]: prev[name].map((item, i) => 
                i === index ? { ...item, [field]: value } : item
            )
        }))
    }




    const addImagen = () => {
        setFormData(prev => ({
            ...prev,
            productos_imagenes: [...prev.productos_imagenes, { titulo: '', archivo: "", descripcion: '', id: '', archivoUrl: '', orden: 0 }]
        }));
    };
    const addImagenPequena = () => {
        setFormData(prev => ({
            ...prev,
            productos_imagenes_pequenas: [...prev.productos_imagenes_pequenas, { titulo: '', archivo: "", descripcion: '', id: '', archivoUrl: '', orden: 0 }]
        }));
    };

    const removeImagen = (index: number) => {
        const imagenEliminada = formData.productos_imagenes[index];
        if (imagenEliminada?.id) {
            setImagesEliminadas(prev=>[...prev, imagenEliminada.id])
        }

        setFormData(prev => {
          
            const updatedImagenes = [...prev.productos_imagenes];
            updatedImagenes.splice(index, 1);

          return {
            ...prev,
            productos_imagenes: updatedImagenes
          }  
        });
    };
    
    const removeImagenPequena = (index: number) => {
        console.log(index)
        const imagenEliminada = formData.productos_imagenes_pequenas[index];
        if (imagenEliminada?.id) {
            setImagesPequenasEliminadas(prev => [...prev, imagenEliminada.id]);
        }
        
        setFormData(prev => {
          
            const updatedImagenes = [...prev.productos_imagenes_pequenas];
            updatedImagenes.splice(index, 1);

          return {
            ...prev,
            productos_imagenes_pequenas: updatedImagenes
          }  
        });
    }
    

    return {
        handleSubmit,
        onChange,
        formData,
        images,
        setImages,
        setFormData,
        handleImageFieldChange,
        addImagen,
        addImagenPequena,
        removeImagenPequena,
        removeImagen,
        loading
    }

}

export default useProductoAdd